import { render, staticRenderFns } from "./PersonList.vue?vue&type=template&id=7e479fc5&scoped=true&"
import script from "./PersonList.vue?vue&type=script&lang=js&"
export * from "./PersonList.vue?vue&type=script&lang=js&"
import style0 from "./PersonList.vue?vue&type=style&index=0&id=7e479fc5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e479fc5",
  null
  
)

export default component.exports